import {
    createAction
} from "redux-actions";
import axios from 'axios';

import {
    BACKEND_URL as BACKEND_URL_MAIN,
    BACKEND_URL_MAIN as BACKEND_URL
} from '../../config.js';


const GET_EDITOR = createAction("GET_EDITOR");
const GET_EDITOR_LOAD = createAction("GET_EDITOR_LOAD");


export const getEditor  = (reportId) => dispatch => {
    dispatch(GET_EDITOR_LOAD())
    return axios.get(
        BACKEND_URL + `/v1/explore/getEditor?reportId=${reportId}`, {
            headers: {
                token: localStorage.getItem("token")
            }
        }
    ).then((res) => {
        dispatch(GET_EDITOR({data: res.data}))
    }).catch((err) => {
        dispatch(GET_EDITOR({data: null}))
    })
};


export const MeUpload = values => dispatch => {
    const formData = new FormData();
    formData.append('file',values.file_source);
    formData.append('publication_date',values.publication_date);
    formData.append("sku",values.sku);
    formData.append("tags",values.tags);
    formData.append("domain",values.domain);
    console.log(values, BACKEND_URL_MAIN)
    return axios.post(
        BACKEND_URL_MAIN + "/v1/explore/meupload", formData,{
            headers:{
                token:localStorage.getItem("token")
            }
        }
    ).then((res) => {
        console.log(res)
        // dispatch(ADD_TABLE_OF_CONTENT(res.data));
    }).catch((err) => {
        // dispatch(ADD_TABLE_OF_CONTENT(err));
    })
}



// WEBPACK FOOTER //
// ./src/store/Actions/EditorActions.js